const pendingFilesByState = new WeakMap();
const contextItemUploadFilesByState = new WeakMap();
const captureSessionsByState = new WeakMap();

export function rememberPendingAttachmentFile(state, pendingID, file) {
  if (!state || !pendingID || !file) {
    return;
  }
  filesForState(state).set(String(pendingID), file);
}

export function pendingAttachmentFile(state, pendingID) {
  if (!state || !pendingID) {
    return null;
  }
  return filesForState(state).get(String(pendingID)) || null;
}

export function forgetPendingAttachmentFile(state, pendingID) {
  if (!state || !pendingID) {
    return;
  }
  filesForState(state).delete(String(pendingID));
}

export function setContextItemUploadFiles(state, files) {
  if (!state) {
    return;
  }
  const selected = Array.isArray(files) ? files.filter(Boolean) : [];
  if (selected.length === 0) {
    contextItemUploadFilesByState.delete(state);
    return;
  }
  contextItemUploadFilesByState.set(state, selected);
}

export function contextItemUploadFiles(state) {
  if (!state) {
    return [];
  }
  return [...(contextItemUploadFilesByState.get(state) || [])];
}

export function clearContextItemUploadFiles(state) {
  if (!state) {
    return;
  }
  contextItemUploadFilesByState.delete(state);
}

export function setThreadCaptureSession(state, session) {
  if (!state || !session) {
    return;
  }
  const previous = captureSessionsByState.get(state);
  if (previous && previous !== session) {
    previous.cancel?.();
  }
  captureSessionsByState.set(state, session);
}

export function threadCaptureSession(state) {
  if (!state) {
    return null;
  }
  return captureSessionsByState.get(state) || null;
}

export function clearThreadCaptureSession(state, options = {}) {
  if (!state) {
    return null;
  }
  const session = captureSessionsByState.get(state) || null;
  if (!session) {
    return null;
  }
  if (options.cancel === true) {
    session.cancel?.();
  }
  captureSessionsByState.delete(state);
  return session;
}

export function clearTransientThreadMediaState(state) {
  if (!state) {
    return;
  }
  clearThreadCaptureSession(state, { cancel: true });
  pendingFilesByState.delete(state);
  contextItemUploadFilesByState.delete(state);
}

function filesForState(state) {
  let files = pendingFilesByState.get(state);
  if (!files) {
    files = new Map();
    pendingFilesByState.set(state, files);
  }
  return files;
}
